export const name = "JUSTIFY_DAYS";
export const summary = `Normalizes the day part of an \`INTERVAL\` value.`;
export const reference = `
## JUSTIFY_DAYS

Normalizes the day part of an \`INTERVAL\` value.

\`\`\`
JUSTIFY_DAYS(interval_expression)
\`\`\`

### Description

Normalizes the day part of the interval to the range from -29 to 29 by incrementing/decrementing the month or year part of the interval.


### Return Data Type

\`INTERVAL\`


### Example



\`\`\`
SELECT
  JUSTIFY_DAYS(INTERVAL 29 DAY) AS i1,
  JUSTIFY_DAYS(INTERVAL -30 DAY) AS i2,
  JUSTIFY_DAYS(INTERVAL 31 DAY) AS i3,
  JUSTIFY_DAYS(INTERVAL -65 DAY) AS i4,
  JUSTIFY_DAYS(INTERVAL 370 DAY) AS i5

/*--------------+--------------+-------------+---------------+--------------*
 | i1 | i2 | i3 | i4 | i5 |
 +--------------+--------------+-------------+---------------+--------------+
 | 0-0 29 0:0:0 | -0-1 0 0:0:0 | 0-1 1 0:0:0 | -0-2 -5 0:0:0 | 1-0 10 0:0:0 |
 *--------------+--------------+-------------+---------------+--------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/interval_functions
`;
